<template>
    <div class="col-lg-12">
        <div class="apprentice-simple-card">
            <div class="title">
                <h5>{{ $t('group_pair.compound') }}</h5>
            </div>

            <design-2021-apprentice-data-table
                :items="usersIn"
                :fields="fields"
                :nosearch="true">
                <template v-slot:cell(actions)="data">
                    <b-button
                        class="btn-remove btn-remove-skill-tree remove-icon-margin"
                        v-b-tooltip.hover
                        v-if="data.item.removable"
                        variant="danger-icon-only"
                        :title="$t('common.delete')"
                        @click="removeUser(data.item)">
                    </b-button>
                </template>
            </design-2021-apprentice-data-table>
        </div>
    </div>
</template>

<script>
export default {
    name: 'design-2021-group-pair-current-group-component',
    props: ['usersIn'],
    data() {
        return {
            fields: [
                {
                    key: 'name',
                    label: this.$t('common.name'),
                },
                {
                    key: 'type',
                    label: 'Type',
                },
                {
                    key: 'actions',
                    label: this.$t('common.delete'),
                },
            ],
        };
    },
    methods: {
        removeUser(user) {
            if (user.type === 'Student') {
                this.$emit('remove-student', user.id);
            } else if (user.type === 'Docent') {
                this.$emit('remove-teacher', user.id);
            }
        },
    },
};
</script>

<style scoped lang="scss">
.actions {
    display: flex;
    align-items: center;

    button:not(:last-child) {
        margin-right: map-get($grid-gutter-spacing, 'eight');
    }
}
</style>
